export default function Loader() {
  return (
    <article className='loader-container'>
      <div className='loader'></div>
      <p>Loading questions...</p>
    </article>
  );
}
